import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { BottomDrawer } from 'common/views/atoms/BottomDrawer/BottomDrawer'
import { closeEditDrawer } from 'manager/redux/referral'
import ReferralEditTransaction from './ReferralEditTransaction'
import ReferralEditContact from './ReferralEditContact'

const EditDrawer = (props) => {
  const { closeEditDrawer, location } = props

  const editTransaction = location.query.edit
  const addTransaction = location.query.add
  const editContact = location.query.contact

  let title
  if (editTransaction) {
    title = 'Edit Transaction Details'
  }

  if (addTransaction) {
    title = 'Add Transaction'
  }

  if (editContact) {
    title = 'Edit Contact Info'
  }

  return (
      <BottomDrawer
          title={title}
          className="EditDrawer"
          onClose={ closeEditDrawer }
          isOpen={ !!(editTransaction || addTransaction || editContact) }
          fullscreen={ !!(editTransaction || addTransaction || editContact) }>
          { (editTransaction || addTransaction) && <ReferralEditTransaction {...props} /> }
          { editContact && <ReferralEditContact {...props} /> }
      </BottomDrawer>
  )
}

const selector = (state) => {
  return {}
}

const actions = {
  closeEditDrawer,
}

const withRedux = connect(selector, actions)

export const ReferralEditDrawer = withRedux(withRouter(EditDrawer))
